import imageGinocchio from '../../assets/trattamenti/ginocchio.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';


export default function Ginocchio() {

    const ginocchioContent = <>
    <div className='text-left w-3/4 mx-auto p-5'>
        <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-lg  mb-16 text-white `} > 
            <ul>
                <li className="mb-5 pb-3 border-b-2 border-[#65806E]">
                    <b>Lesioni Legamentose:</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, pressoterapia, game ready, fase del RTP.
                </li>
                <li className="mb-5 pb-3 border-b-2 border-[#65806E]">
                <b>Tendinopatie:</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia, pressoterapia, fase del RTP.
                </li>
                <li className="mb-5 pb-3 border-b-2 border-[#65806E]">
                <b>Sindrome Femoro-Rotulea:</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia.
                </li>
            </ul>
        </div>
    </div>
    </>
    return <>
        <BackgroundImgBlur src={imageGinocchio} title={'GINOCCHIO'} content={ginocchioContent} hscreen={true}/>
    </>
}